import { render, staticRenderFns } from "./download-wallpaper.vue?vue&type=template&id=14fa9958&lang=pug&"
import script from "./download-wallpaper.vue?vue&type=script&lang=js&"
export * from "./download-wallpaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports